import { Component, OnInit } from '@angular/core';
import { Paymentterm } from '../paymentterm';
import { PaymenttermService } from '../paymentterm.service';

import { ActivatedRoute, Params } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { Location } from '@angular/common';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-paymentterm-list',
  templateUrl: './paymentterm-list.component.html',
  styleUrls: ['./paymentterm-list.component.css']
})
export class PaymenttermListComponent implements OnInit {

  closeResult: string; 
  page=1;
    
  currentPage = 1;
  itemsPerPage = 5;
  pageSize: number;
  paymentterm = new Paymentterm();  //Po is defined from abobe import po
  paymentterms: Paymentterm[];
  submitted = false;
  message: string;	
  requester: any [];

  paymenttermFilter: any = { paymentterms: '' };
  totalrecord:number;

  constructor(private paymenttermService: PaymenttermService,
    private route: ActivatedRoute,
    private spinnerService: Ng4LoadingSpinnerService,
    private location: Location,
    private modalService: NgbModal
    ) { }

    // open(content,paymentid) {
    // //  this.GetDepartmentDetails(deptid);
    //   this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
    //     this.closeResult = `Closed with: ${result}`;
    //   }, (reason) => {
    //     this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    //   });
    // }

    // private getDismissReason(reason: any): string {
    //   if (reason === ModalDismissReasons.ESC) {
    //     return 'by pressing ESC';
    //   } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
    //     return 'by clicking on a backdrop';
    //   } else {
    //     return  `with: ${reason}`;
    //   }
    // }

  ngOnInit(): void {
    this.getPaymentterms();

  }



  getPaymentterms() {
    this.spinnerService.show();    
    return this.paymenttermService.getPaymentterms()
               .subscribe(
                paymentterms => {              
                  this.paymentterms = paymentterms
                  this.spinnerService.hide();
                  this.totalrecord = this.paymentterms.length;
                  
                 }
                );
 }


 update(): void {
  this.submitted = true;
  this.paymenttermService.updatePaymentterm(this.paymentterm)
      .subscribe(() => this.message = "Payment Term Updated Successfully!");
}

delete(paymenttermid): void {
  this.submitted = true;
  this.paymenttermService.deletePaymentterm(paymenttermid)
      .subscribe(()=> this.message = "Payment Term Deleted Successfully!");
    this.getPaymentterms();  
}


  public onPageChange(pageNum: number): void {
  this.pageSize = this.itemsPerPage*(pageNum - 1);
}

public changePagesize(num: number): void {
this.itemsPerPage = this.pageSize + num;
}

}
